import type { components } from 'api/partnerApiSchema';

export enum PaymentMethod {
    Prepaid = 'prepaid',
    CashOnDelivery = 'cod',
}

export type TypeOfService = components['schemas']['DeliveryRequest']['typeOfService'];
